import auth from "./auth";
import router from "../router";
import axios from "axios";
import qs from "qs";

export default {
  api(config = {}, noAuth = false) {
    config.baseURL = process.env.VUE_APP_API_URL;
    let api = axios.create(config);

    if (!noAuth && auth.isLoggedIn()) {
      api.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${auth.getAccessToken()}`;
    }

    api.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        // redirect 401 errors to login page
        if (error.response && error.response.status == 401) {
          auth.logout();
          router.push("/login").catch(_err => {});
          router.go();
        }

        return Promise.reject(error);
      }
    );

    return api;
  },
  get(url, parameters) {
    let queryString = "";
    if (parameters) {
      queryString += Object.keys(parameters)
        .map(function(key) {
          if (Array.isArray(parameters[key])) {
            return parameters[key]
              .map(function(value) {
                return key + "=" + value;
              })
              .join("&");
          } else {
            return key + "=" + parameters[key];
          }
        })
        .join("&");

      url += "?" + queryString;
    }
    return this.api().get(url);
  },
  getWithParams(url, queryParams) {
    url += "?" + queryParams.toString();
    return this.api().get(url);
  },
  getFile(url) {
    return this.api({ responseType: "blob" }).get(url);
  },
  post(url, parameters) {
    return this.api().post(url, qs.stringify(parameters), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },
  postJSON(url, parameters, options) {
    return this.api().post(url, parameters, options);
  },
  postToS3(url, form, uploadCallback) {
    const config = {
      onUploadProgress: uploadCallback
    };
    return this.api(config, true).post(url, form, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  uploadFile(url, parameters, uploadCallback) {
    const config = {
      onUploadProgress: uploadCallback
    };
    return this.api(config).post(url, parameters, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  put(url, parameters) {
    return this.api().put(url, parameters);
  },
  delete(url, parameters) {
    let config = {};
    if (parameters) {
      config.data = parameters;
    }
    return this.api().delete(url, config);
  }
};
